import { I18n } from '@affine/i18n';

import type { WorkflowAttachment } from '../ai-chat-content/type';

function getVersionRoleLabel(workflow: WorkflowAttachment): string | null {
  switch (workflow.versionRole) {
    case 'draft':
      return I18n.t('com.streamlain.streamlain.workflow.draft');
    case 'published':
      return I18n.t('com.streamlain.streamlain.workflow.published');
    case 'snapshot':
      return I18n.t('com.streamlain.streamlain.workflow.snapshot');
    default:
      return null;
  }
}

export function getWorkflowAttachmentLabel(
  workflow: WorkflowAttachment
): string {
  const role = getVersionRoleLabel(workflow);
  if (workflow.workflowName && role) {
    const version =
      typeof workflow.version === 'number' ? ` v${workflow.version}` : '';
    return `${I18n.t('com.streamlain.ai.context.workflow')} ${workflow.workflowName} · ${role}${version}`;
  }

  const nodeCount = workflow.selectedNodes.length;
  const nodeNames = workflow.selectedNodes
    .map(node => node.name)
    .slice(0, 3)
    .join(', ');
  const nodeLabel = I18n.t('com.streamlain.ai.context.workflow.nodes', {
    count: nodeCount,
  });
  return nodeCount <= 3
    ? `${nodeLabel}: ${nodeNames}`
    : `${nodeLabel}: ${nodeNames}...`;
}

export function getWorkflowAttachmentMeta(
  workflow: WorkflowAttachment
): string {
  if (workflow.scope === 'whole-workflow') {
    return I18n.t('com.streamlain.ai.context.workflow.nodes', {
      count: workflow.selectedNodes.length,
    });
  }
  return I18n.t('com.streamlain.ai.context.selected', {
    count: workflow.selectedNodes.length,
  });
}
